<template lang="pug">
  .RadialProgress
    svg.RadialProgress_svg(
      :style="svgStyles"
      :width="diameter"
      :height="diameter"
      :viewbox="`0 0 ${diameter} ${diameter}`"
    )
      circle.RadialProgress_circle(
        fill="none"
        stroke="currentColor"
        :cx="diameter/2"
        :cy="diameter/2"
        :r="placeholderCircleRadius"
        :stroke-width="placeholderStrokeWidth"
      )
      circle.RadialProgress_circle(
        fill="none"
        stroke="currentColor"
        :cx="diameter/2"
        :cy="diameter/2"
        :r="progressCircleRadius"
        :stroke-width="progressStrokeWidth"
        :stroke-dasharray="strokeDasharray"
        :stroke-dashoffset="strokeDashoffset"
      )

</template>

<script>

export default {
  props: {
    progress: {
      default: 0
    },
    diameter: {
      type: Number,
      default: 64
    },
    placeholderStrokeWidth: {
      type: Number,
      default: 1
    },
    progressStrokeWidth: {
      type: Number,
      default: 4
    },
    startAngle: {
      type: Number,
      default: -90
    }
  },
  computed: {
    placeholderCircleRadius () {
      return this.diameter / 2 - this.placeholderStrokeWidth / 2 - (this.progressStrokeWidth - this.placeholderStrokeWidth) / 2
    },
    progressCircleRadius () {
      return this.diameter / 2 - this.progressStrokeWidth / 2
    },
    strokeDasharray () {
      return 2 * Math.PI * this.progressCircleRadius
    },
    strokeDashoffset () {
      return this.strokeDasharray * (1 - this.progress)
    },
    svgStyles () {
      return {
        transform: `rotateZ(${this.startAngle}deg)`
      }
    }
  },
  data () {
    return {}
  },
  mounted () {

  }
}

</script>

<style lang="stylus" scoped>
.RadialProgress
  &_svg
    display: block
    position relative
</style>
